module.exports = __webpack_public_path__ + "static/media/sdk-logo.976a39da.svg";